import SectionLabel from '../shared/SectionLabel';
import '../../styles/leadershippage.css';

interface Member {
  _id: string;
  name: string;
  title: string;
  department: string;
  bio: string;
  photo?: string;
  linkedin?: string;
  twitter?: string;
}

interface Props {
  members: Member[];
  isLoading?: boolean;
}

function getInitials(name: string) {
  return name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}

const memberPhotoMap: Record<string, string | null> = {
  'Pramod Attarde':  '/members/PramodAttarde.png',
  'Jamil':           '/members/jamil.jpeg',
  'Lalit Shinde':    '/members/lalitShinde.jpeg',
  'Makis':           '/members/makis.jpeg',
  'Sanjay Kamtekar': '/members/sanjay kamtekar.jpeg',
  'Sunita Attarde':  '/members/sunita attarde.jpeg',
  'Indy Samra':      'https://nova-portal-uploads.s3.us-east-2.amazonaws.com/uploads/6c7323d5c4fff3dd38c8105f843ce9f8.jpeg',
};

function getMemberPhoto(member: Member): string | undefined {
  if (member.photo) return member.photo;
  for (const [key, path] of Object.entries(memberPhotoMap)) {
    if (path && member.name.toLowerCase().includes(key.toLowerCase())) return path;
  }
  return undefined;
}

export default function LeadershipSection({ members, isLoading }: Props) {
  return (
    <div className="ldp-page">
      <section className="ldp-team-section" style={{ borderBottom: 'none' }}>
        <div className="ldp-shell">
          <div className="ldp-section-header">
            <SectionLabel>Leadership</SectionLabel>
            <h2 className="ldp-section-title">
              The Team Behind <em>Apex</em>
            </h2>
            <p className="ldp-section-sub">
              Seasoned executives driving innovation across decentralized finance, AI, and next-generation technology.
            </p>
          </div>

          {isLoading ? (
            <div className="ldp-team-grid">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="ldp-team-card ldp-team-card--loading">
                  <div className="ldp-team-card-top">
                    <div className="ldp-team-avatar ldp-skeleton" />
                    <div className="ldp-skeleton-lines">
                      <div className="ldp-skeleton ldp-skeleton--name" />
                      <div className="ldp-skeleton ldp-skeleton--role" />
                    </div>
                  </div>
                  <div className="ldp-skeleton ldp-skeleton--bio" />
                </div>
              ))}
            </div>
          ) : (
            <div className="ldp-team-grid">
              {members.map((m) => (
                <div key={m._id} className="ldp-team-card">
                  <div className="ldp-team-card-top">
                    <div className="ldp-team-avatar">
                      {getMemberPhoto(m)
                        ? <img src={getMemberPhoto(m)} alt={m.name} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        : getInitials(m.name)}
                    </div>
                    <div>
                      <h3 className="ldp-team-name">{m.name}</h3>
                      <span className="ldp-team-role">{m.title}</span>
                      {m.department && <span className="ldp-team-dept">{m.department}</span>}
                    </div>
                  </div>
                  <div className="ldp-team-bio" dangerouslySetInnerHTML={{ __html: m.bio }} />
                  {(m.linkedin || m.twitter) && (
                    <div className="ldp-team-socials">
                      {m.linkedin && (
                        <a href={m.linkedin} target="_blank" rel="noreferrer" className="ldp-team-social-link">in</a>
                      )}
                      {m.twitter && (
                        <a href={m.twitter} target="_blank" rel="noreferrer" className="ldp-team-social-link">𝕏</a>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
